export interface StatisticState {
  callStatisticDetail?: any,
  callStatisticDetailFlag?: string,
  callStatisticDetailIncoming?: DetailIncomingItem[];

  callStatisticGroup?: CallGroupItem[],
  callStatisticGroupMessageCount?: number,
  callStatisticGroupIncoming?: CallGroupIncomingItem[],
  callStatisticGroupIncomingMessageCount?: number,
  callGroupings: {
    callGroup: string[],
    callGroupByOptionally: string[],
    callGroupByIncoming: string[],
    callGroupByOptionallyIncoming: string[],
  },
}

export class DetailFilterParams {
  date_from: string;
  date_to: string;
  originator?: string = undefined;
  recipient?: string = undefined;
  partner?: string = undefined;
  service_provider?: string = undefined;
  status?: string = undefined;
  error_code?: number = undefined;
  message_type?: string = undefined;
  start_date_from?: string = undefined;
  start_date_to?: string = undefined;
  end_date_from?: string = undefined;
  end_date_to?: string = undefined;
  template_id?: number = undefined;
  bulk_id?: number = undefined;
  operator?: string = undefined;
  broker_account_login?: string = undefined;
  partner_user_login?: string = undefined;
  id?: string = undefined;
  external_id?: string = undefined;
  ext_id1?: string = undefined;
  ext_id2?: string = undefined;
  ext_id3?: string = undefined;
  ext_id4?: string = undefined;
  ext_id5?: string = undefined;
  page_number: number = 1;
  message_direction: string;

  constructor(date_from: string, date_to: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.message_direction = "mt";
  }
}

export interface DetailItem {
  id: string,
  create_date: string,
  originator: string,
  recipient: string,
  partner: string,
  service_provider: string,
  content: string,
  status: string,
  error_code: number|null,
}

// - - -

export class CallGroupFilterParams {
  date_from: string;
  date_to: string;
  group_by: string;
  originator?: string = undefined;
  service_provider?: string = undefined;
  partner?: string = undefined;
  country?: string = undefined;
  operator?: string = undefined;
  template_id?: number = undefined;
  bulk_id?: number = undefined;
  broker_account_login?: number = undefined;
  message_type?: number = undefined;
  message_direction: string;

  constructor(date_from: string, date_to: string, group_by: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.group_by = group_by;
    this.message_direction = "mt";
  }
}

export interface CallGroupItem {
  date?: string;
  originator?: string;
  service_provider?: string;
  partner?: string;
  operator?: string;
  template_id?: string;
  bulk_id?: string;
  finished: number;
  not_answered: number;
  failed: number;
  rejected: number;
  buffered: number;
  duration: number;
  total: number;
  partner_price: string;
  provider_price: string;
}

// - - -

export class CallGroupIncomingFilterParams {
  date_from: string;
  date_to: string;
  group_by: string;
  partner?: string = undefined;
  service_number?: string = undefined;
  originator_operator?: string = undefined;
  message_direction: string;

  constructor(date_from: string, date_to: string, group_by: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.group_by = group_by;
    this.message_direction = "mo";
  }
}

export interface CallGroupIncomingItem {
  date?: string;
  service_number?: string;
  partner?: string;
  originator_operator?: string;
  finished: number;
  failed: number;
  total: number;
  duration: number;
}

export class DetailIncomingFilterParams {
  id?: string = undefined;
  date_from: string;
  date_to: string;
  originator?: string = undefined;
  service_number?: string = undefined;
  partner?: string = undefined;
  status?: string = undefined;
  error_code?: number = undefined;
  page_number: number = 1;
  message_direction: string;

  constructor(date_from: string, date_to: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.message_direction = "mo";
  }
}

export interface DetailIncomingItem {
  id: string;
  create_date: string;
  originator: string;
  service_number: string;
  partner: string;
  content: string;
  status: string;
  error_code?: number;
}

export interface DetailIncomingItemInfo extends DetailIncomingItem {
  start_date: string;
  end_date: string;
  duration: string;
  module: string;
  originator_operator?: string;
  originator_country?: string;
  error_description?: string;
}
